import { defineMessages } from 'react-intl';

export default defineMessages({
    header: {
        id: '_.confirm_funding.header',
        defaultMessage: 'We’re all set to send funds to your account{tooltip}'
    },
    interestOnlyHeader: {
        id: '_.confirm_funding.interestOnlyHeader',
        defaultMessage: 'We are ready to extend your loan{tooltip}'
    },
    repaymentReductionHeader: {
        id: '_.confirm_funding.repayment_reduction_header',
        defaultMessage: 'We are ready to reduce your monthly repayments'
    },
    rcfFirstDrawdownHeader: {
        id: '_.confirm_funding.rcf_first_drawdown_header',
        defaultMessage: 'Confirm your first payout'
    },
    rcfSubsequentDrawdownHeader: {
        id: '_.confirm_funding.rcf_subsequent_drawdown_header',
        defaultMessage: 'We are ready to transfer the money to your account.'
    },
    tooltip: {
        id: '_.confirm_funding.tooltip',
        defaultMessage:
            "You can adjust your choice by clicking 'Go back' below."
    },
    subHeader: {
        id: '_.confirm_funding.subheader',
        defaultMessage: 'Just hit ‘Confirm’ to send the funds to your account.'
    },
    interestOnlySubHeader: {
        id: '_.confirm_funding.interestOnlySubHeader',
        defaultMessage: 'Just hit ‘Confirm’ to extend your loan.'
    },
    rcfFirstDrawdownSubHeader: {
        id: '_.confirm_funding.rcf_first_drawdown_subheader',
        defaultMessage:
            'Click on ‘Confirm Payout’ to receive your first payout and activate your credit line. You can withdraw money again at any time afterwards.'
    },
    rcfSubsequentDrawdownSubHeader: {
        id: '_.confirm_funding.rcf_subsequent_drawdown_subheader',
        defaultMessage:
            'Simply click ‘Confirm’ to transfer the money to your account. We are ready when you are!'
    },
    repaymentReductionSubHeader: {
        id: '_.confirm_funding.repayment_reduction_subheader',
        defaultMessage:
            'Click on confirm to reduce your monthly repayments. We’re ready when you are!'
    },
    summaryTitleDrawDown: {
        id: '_.confirm_funding.summary_title',
        defaultMessage: 'You are requesting to borrow'
    },
    summaryTitleTopUp: {
        id: '_.confirm_funding.top_up.summary_title',
        defaultMessage: 'You are requesting to withdraw'
    },
    summaryTitleInterestOnly: {
        id: '_.confirm_funding.top_up.interestOnly_summary_title',
        defaultMessage: 'You are extending your interest-only period'
    },
    confirm: {
        id: '_.confirm_funding.confirm',
        defaultMessage: 'Confirm'
    },
    paidInTo: {
        id: '_.confirm_funding.paid_in_to',
        defaultMessage: 'Paid into'
    },
    repaidFrom: {
        id: '_.confirm_funding.repaid_from',
        defaultMessage: 'Repaid from'
    },
    summaryBreakdownDrawDown: {
        id: '_.confirm_funding.confirm_repayment.summary_breakdown',
        defaultMessage:
            'This will set your outstanding balance to {newBalance}.'
    },
    summaryBreakdownTopUp: {
        id: '_.confirm_funding.top_up.confirm_repayment.summary_breakdown',
        defaultMessage:
            'This will increase your outstanding balance to {newBalance}.'
    },
    repaymentBreakdown: {
        id: '_.confirm_funding.repayment_breakdown',
        defaultMessage: 'See full repayment schedule'
    },
    repaymentFromExplanation: {
        id: '_.confirm_funding.repayment_from_explanation',
        defaultMessage: 'Repayment from explanation'
    }
});
